import * as React from 'react'
import { getCatalogProductsAddTable } from '../../../Model/CatalogProduct'
import { observer } from 'mobx-react'

export interface IAddProductsCreateQProps {
    pageSize?: number
}
@observer
export default class AddProductsCreateQ extends React.Component<IAddProductsCreateQProps> {
    render() {
        const { pageSize } = this.props
        return getCatalogProductsAddTable(pageSize ? pageSize : 5)
    }
} 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/AddProductsCreateQ.tsx